import { HISTORICAL_DATA_URL } from "../../../utils/constService";
import api from "../../../../BasicComponent/Service/api";

export const fetchHistoricalData = (params) => {
  return api.get(HISTORICAL_DATA_URL, {
    params,
  });
};
